<!-- Page tabs list -->
<div class="flex justify-between gap-2">
  <ng-content></ng-content>
</div>
